import { gql } from './apollo';

export const GET_ATTACHMENTS_FOR_PARENT = gql`
    query ($parent_id: MultiTypeInput!, $parent_table: MultiTypeInput!) {
        table(
            name: "gc_inventory_attachments"
            filter: [
                { left: "parent_id", right: $parent_id, expression: "=" }
                { left: "parent_table", right: $parent_table, expression: "=" }
            ]
            contain: [
                {
                    table: "propertyuser__c"
                    alias: "uploaded_by_propertyuser__c"
                    columns: ["name"]
                    fk: "id"
                    joinFk: "uploaded_by"
                    limit: 1
                }
            ]
            orderBy: "uploaded_at"
            orderByDirection: DESC
            limit: 100
        )
    }
`;

export const DELETE_ATTACHMENT = gql`
    mutation ($id: String!) {
        deleteRow(table: "gc_inventory_attachments", id: $id)
    }
`;
